import { render, staticRenderFns } from "./EditSections.vue?vue&type=template&id=6be974da&scoped=true"
import script from "./EditSections.vue?vue&type=script&lang=js"
export * from "./EditSections.vue?vue&type=script&lang=js"
import style0 from "./EditSections.vue?vue&type=style&index=0&id=6be974da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be974da",
  null
  
)

export default component.exports